import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { CalendarBlank, ChatCentered, ChartLine, CreditCard, CheckSquareOffset, EnvelopeSimple, File, LockSimple, Package, PaintBrushBroad, PaperPlaneTilt, Plug, Table, Textbox, User } from '@phosphor-icons/react'

const icons = {
   analytics: ChartLine,
   chat: PaperPlaneTilt,
   checkin: CheckSquareOffset,
   discuss: ChatCentered,
   email: EnvelopeSimple,
   event: CalendarBlank,
   file: File,
   integrations: Plug,
   payments: CreditCard,
   // liveEvents: <Calendar />,
   // checkInDesk: <QrCode />,
   form: Textbox,
   marketplace: Package,
   privacy: LockSimple,
   schedule: Table,
   theme: PaintBrushBroad,
   user: User
}

const AccordionItem = ({ title, description, icon, isOpen, onClick }) => {
   const contentHeight = useRef()
   const Icon = icons[icon]

   return (
      <div className="flex flex-col gap-0 text-sm xl:text-base w-100 hover:bg-white/10 cursor-pointer overflow-hidden">
         <div
            className={`flex items-center gap-0 border-t border-solid border-white/20 w-100 py-3 ${isOpen ? 'active' : ''}`}
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
               if (e.key === 'Enter' || e.key === ' ') {
                  onClick()
               }
            }}>
            <div className="w-12 pl-1 flex items-center flex-0 opacity-40">
               <Icon size={22} />
            </div>
            <span className="flex-1 text-white">{title}</span>
         </div>

         <div
            ref={contentHeight}
            className="bg-black transition-all duration-300"
            style={isOpen ? { height: contentHeight?.current?.scrollHeight } : { height: '0px' }}>
            <div className="pl-12 text-white/70 mt-1 pb-6">{description}</div>
         </div>
      </div>
   )
}

AccordionItem.propTypes = {
   title: PropTypes.string.isRequired,
   description: PropTypes.string.isRequired,
   icon: PropTypes.string.isRequired,
   isOpen: PropTypes.bool.isRequired,
   onClick: PropTypes.func.isRequired
}

export default AccordionItem
